import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getAmountColumnConfig } from '../../../../utils/getAmountColumnConfig'
import { AmountKey } from '../enums/amountKey'
import type { AmountField } from '../types/amountField'

interface UseColumnLabelsProps {
  countryId: string | undefined
  fields: AmountField[] | undefined
}

export const useColumnLabels = ({ countryId, fields }: UseColumnLabelsProps) => {
  const { t } = useTranslation()

  return useMemo(() => {
    const { labels, amountKeys } = getAmountColumnConfig(countryId, fields ?? [], t)
    return {
      labels,
      amountKeys: amountKeys.map((key) => (key === 'turnoverAmount' ? AmountKey.Turnover : AmountKey.Vat)),
    }
  }, [fields, countryId, t])
}
